import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  Outlet,
} from "react-router-dom";


import { Provider, useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState, store } from "./redux/store";
import { fetchAllUsers, listenForAuthChanges } from "./redux/authSlice";

/* ── Pages ────────────────────────────────────────────────── */
import AuthSwitch           from "./AUTH/AuthSwitch";
import VerificationOverview from "./AUTH/VERIFICATION/VerificationOverview";
import VerifyEmail          from "./AUTH/VERIFICATION/VerifyEmail";
import AccountSettings      from "./PROFILE/AccountSettings";
import EditProfile          from "./PROFILE/EditProfile";
import LoginSecurity        from "./PROFILE/LoginSecurity";
import Profile              from "./PROFILE/Profile";
import ProfileSettings      from "./PROFILE/ProfileSettings";

import ComingSoon from "./GLOBAL/ComingSoon";
import CentralHome from "./APPCENTRAL/CentralHome";
import { CurrencyProvider } from "@cosmoola/react-cosmoola-js";
import MerchantOnboarding from "./APPCENTRAL/B2B/MerchantOnboarding";
import Subscription from "./APPCENTRAL/B2B/Subscription";
import MerchantDashboard from "./APPCENTRAL/B2B/MerchantDashboard";


/* ══════════════════════════════════════════════════════════
   Loader
══════════════════════════════════════════════════════════ */
const Loader = () => (
  <div style={{
    minHeight: "100vh", display: "flex", flexDirection: "column",
    alignItems: "center", justifyContent: "center",
    background: "#F8F9FA", gap: 16,
  }}>
    <div style={{ display: "flex", gap: 8 }}>
      {["#4285F4", "#EA4335", "#34A853", "#FBBC05"].map((c, i) => (
        <div key={c} style={{
          width: 12, height: 12, borderRadius: "50%", background: c,
          animation: "bounce 1.2s infinite ease-in-out",
          animationDelay: `${i * 0.15}s`,
        }} />
      ))}
    </div>
    <span style={{
      fontSize: 13, color: "#5F6368",
      fontFamily: "'Nunito', sans-serif", fontWeight: 600, letterSpacing: "0.05em",
    }}>
      Loading eBUOS...
    </span>
    <style>{`
      @keyframes bounce {
        0%, 80%, 100% { transform: scale(0.6); opacity: 0.5; }
        40%            { transform: scale(1);   opacity: 1;   }
      }
    `}</style>
  </div>
);

/* ══════════════════════════════════════════════════════════
   App Routes
══════════════════════════════════════════════════════════ */

const AppRoutes = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { user, authLoaded } = useSelector((state: RootState) => state.auth);

  
  useEffect(() => {
    const handleContextMenu = (e: MouseEvent) => {
      e.preventDefault();
    };

    document.addEventListener('contextmenu', handleContextMenu);

    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
    };
  }, []);

  useEffect(() => {
    dispatch(listenForAuthChanges());
  }, [dispatch]);

  
{/*
    useEffect(() => {
  if (user) {
    // 1 hour = 60 minutes × 60 seconds × 1000 ms = 3,600,000 ms
    dispatch(startInactivityWatcher({ timeoutMs: 60 * 60 * 1000 }));
  }
}, [dispatch, user]);
  
  
  */}


{/*
    useEffect(() => {
  if (user) {
    dispatch(startInactivityWatcher({ timeoutMs: 5 * 60 * 1000 })); // 5 min
  }
}, [dispatch, user]);
  
  */}


  useEffect(() => {
    dispatch(fetchAllUsers());
    
 
  }, [dispatch]);
  

  


  if (!authLoaded) {
    return <div style={{ textAlign: "center", marginTop: 100 }}></div>;
  }



  const ProtectedSupportRoute = () => {
    const authUser = useSelector((state: RootState) => state.auth.user);
  
    if (!authUser) return <Navigate to="/AuthSwitch" replace />;
  
    const hasAccess = authUser.role?.includes("support") || authUser.role?.includes("admin");
  
    if (!hasAccess) return <Navigate to="/" replace />;
  
    return <Outlet />;
  };

  return (
    <>

    <Routes>
      {/* ✅ Publicly accessible pages/tabs */}
      <Route
  path="/"
  element={
    <>
    
  
        {/*


    
  <GeneralHomes/>  

    <HomeLive />     

      <WhatsNew /> 
        <Route index element={<Ahome />} />
    
       */}
    </>
  }
/>


   

        <Route path="/" element={<Outlet  />}>

<Route index element={<RootRedirect />} />

<Route path="/comingsoon" element={<ComingSoon />} />
      <Route path="/AuthSwitch" element={<AuthSwitch />} />
     

      </Route>

      {/* ══════════════════════════════════════════════════
          PRIVATE STACK — login required
          Same pattern: {user ? (<> routes </>) : null}
      ══════════════════════════════════════════════════ */}
      {user ? (
        <>
          {/* ── Profile ── */}
          <Route path="/Profile/:userId"         element={<Profile />} />
          <Route path="/editprofile/:userId"      element={<EditProfile />} />
          <Route path="/profilesettings/:userId"  element={<ProfileSettings />} />
          <Route path="/accountsettings/:userId"  element={<AccountSettings />} />
          <Route path="/loginsecurity/:userId"    element={<LoginSecurity />} />

          {/* ── Verification ── */}
          <Route path="/VerificationOverview/:userId" element={<VerificationOverview />} />
          <Route path="/VerifyEmail/:userId"          element={<VerifyEmail />} />


      <Route path="/merchantonboarding/:userId"    element={<MerchantOnboarding />} />

    <Route path="/merchant" element={<MerchantDashboard />} />
  <Route path="/merchantdashboard/:merchantId"  element={<MerchantDashboard />} />

        
           <Route path="subscription/:merchantId" element={<Subscription />} />
  

        </>
      ) : null}

      <Route path="*" element={<Navigate to={user ? "/" : "/authswitch"} replace />} />
       

    
    </Routes>
</>
);};

const RootRedirect: React.FC = () => {
  const { user } = useSelector((s: RootState) => s.auth);
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!user) return;
    const timer = setTimeout(() => setShow(true), 3000);
    return () => clearTimeout(timer);
  }, [user]);

  if (show) return <ComingSoon />;
  return <ComingSoon />;
};

const App = () => (
  <Provider store={store}>
    <Router>
<CurrencyProvider 
  apiKey={process.env.REACT_APP_MOOLABLES_PUBLISHABLE_KEY!}
>

<div style={{
  position: "fixed",
  right: 0,
  top: "50%",
  transform: "translateY(-50%)",
  zIndex: 99999,
  background: "rgba(255,255,255,0.08)",
  backdropFilter: "blur(8px)",
  borderRadius: "8px 0 0 8px",
  padding: "6px 4px",
  border: "1px solid rgba(255,255,255,0.12)",
  borderRight: "none",
}}>
 
</div>
  

      <AppRoutes />

   </CurrencyProvider>
    </Router>
  </Provider>
);

export default App;